import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';
import styles from './styles.styl';

import Title from '../../../Drawer/Title';
import NavItem from '../../../common/NavItem';
import { DEPENDENT_STATUSES } from '../../../../constants/props';

function NavList({
  list,
  title,
  activeUserId,
  onClick,
  loggedUserId,
  subtitleContext,
}) {
  return (
    <Fragment>
      {title && <Title text={title} className="f-12 pa3" />}
      {list.map(item => {
        const isMainUser = loggedUserId === item.id;
        return (
          <NavItem
            title={item.displayableName}
            className={cn({
              [styles.calendar]: item.calendarManageable,
              [styles.calendarActive]:
                item.calendarManageable && activeUserId === item.id,
            })}
            avatar
            avatarUrl={get(item, 'avatar.thumbMin', null)}
            waiting={item.status === DEPENDENT_STATUSES.PENDING}
            unverified={item.status === DEPENDENT_STATUSES.UNVERIFIED}
            key={item.id}
            active={activeUserId === item.id}
            onClick={() => onClick(item.id)}
            subtitle={isMainUser ? subtitleContext : ''}
          />
        );
      })}
    </Fragment>
  );
}

NavList.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
  activeUserId: PropTypes.number,
  onClick: PropTypes.func,
  loggedUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subtitleContext: PropTypes.string,
};

export default NavList;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Navigation/NavList/index.jsx